(() => {
  const header = document.querySelector('[data-tp-header]');
  if (!header) return;

  const toggle = header.querySelector('.tp-menu-toggle');
  const menu = header.querySelector('#TpMobileMenu');
  const links = menu ? menu.querySelectorAll('a') : [];
  if (!toggle || !menu) return;

  const setOpen = (open) => {
    document.body.classList.toggle('tp-menu-open', open);
    header.classList.toggle('is-menu-open', open);
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    menu.hidden = !open;
  };

  toggle.addEventListener('click', () => {
    setOpen(!header.classList.contains('is-menu-open'));
  });

  links.forEach((link) => {
    link.addEventListener('click', () => setOpen(false));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setOpen(false);
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth > 900) setOpen(false);
  }, { passive: true });
})();
